export default {
  future: 'через %s',
  past: '%s назад',
  s: 'несколько секунд',
  ss: 'секунда_секунды_секунд',
  m: 'минута',
  mm: 'минута_минуты_минут',
  h: 'час',
  hh: 'час_часа_часов',
  d: 'день',
  dd: 'день_дня_дней',
  w: 'неделя',
  ww: 'неделя_недели_недель',
  M: 'месяц',
  MM: 'месяц_месяца_месяцев',
  y: 'год',
  yy: 'год_года_лет'
};
